import React from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import Helmet from "react-helmet";
import { Row, Col } from "reactstrap";
import FooterGroup from "./FooterGroup";
import FooterGroupItem from "./FooterGroupItem";

import "./Footer.scss";

const Footer = () => (
  <div className="footer container-fluid">
    <Row className="sitemap">
      <Col xs="0" lg="2"></Col>
      <Col xs="6" lg="2">
        <FooterGroup title="Products">
          <FooterGroupItem>
            <Link to="/products/realfire">Realfire</Link>
          </FooterGroupItem>
          <FooterGroupItem>
            <Link to="/products/scheduleright">Scheduleright</Link>
          </FooterGroupItem>
          <FooterGroupItem>
            <Link to="/products/realsync">Realsync</Link>
          </FooterGroupItem>
          <FooterGroupItem>
            <Link to="/products/libshare">Libshare</Link>
          </FooterGroupItem>
        </FooterGroup>
      </Col>
      <Col xs="6" lg="2">
        <FooterGroup title="Company">
          <FooterGroupItem>
            <Link to="/company/about">About Us</Link>
          </FooterGroupItem>
          <FooterGroupItem>
            <Link to="/company/contact">Contact</Link>
          </FooterGroupItem>
        </FooterGroup>
      </Col>
      <Col xs="6" lg="2">
        <FooterGroup title="Resources">
          <FooterGroupItem>
            <Link to="/resources/docs">Product Docs</Link>
          </FooterGroupItem>
          <FooterGroupItem>
            <Link to="/resources/support">Support</Link>
          </FooterGroupItem>
          <FooterGroupItem>
            <Link to="/resources/eula">Realfire EULA</Link>
          </FooterGroupItem>
          <FooterGroupItem>
            <Link to="/resources/privacy">Privacy Policy</Link>
          </FooterGroupItem>
          <FooterGroupItem>
            <Link to="/resources/credits">Credits</Link>
          </FooterGroupItem>
        </FooterGroup>
      </Col>
      <Col xs="6" lg="2">
        <FooterGroup title="Social">
          <FooterGroupItem>
            <a href="https://twitter.com/datasert">Twitter</a>
          </FooterGroupItem>
          <FooterGroupItem>
            <a href="https://github.com/datasert">Github</a>
          </FooterGroupItem>
          <FooterGroupItem>
            <a href="https://www.linkedin.com/company/datasert">LinkedIn</a>
          </FooterGroupItem>
        </FooterGroup>
      </Col>
      <Col xs="0" lg="2"></Col>
    </Row>
    <Row className="copyright">
      <Col xs="12">© 2017 Datasert Inc. All Rights Reserved</Col>
    </Row>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/Footer.jsx